// import config from "../../nuxt.config";

const state = () => ({
  guides: null,
  trackers: null,
  tracker: {
    pager: { count: 67, pages: 7, items_per_page: 10, current_page: 0 },
    results: [],
  },
  filter: null,
  parents: null,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
};

const actions = {
  async getData({ commit, state }, { url, label }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response.status, url);
      });
  },

  async getDataInfo({ commit, state }, { url, label }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => {
        commit("setData", { label, data: data.data[0] });
        return data.data[0];
      })
      .catch(({ response }) => {
        // console.log(response.status, url);
      });
  },
  async getParent({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => {
        return data.data;
      })
      .catch(({ response }) => {
        // console.log(response.status, url);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
